import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {provideToastr} from 'ngx-toastr';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {provideTranslateService} from '@ngx-translate/core';
import {apiInterceptor} from './interceptors/api.interceptor';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';

const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(MonacoEditorModule.forRoot()),
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideNgxWebstorage(
      withLocalStorage(),
      withSessionStorage()
    ),
    importProvidersFrom(LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: undefined,
      serverLoggingUrl: undefined
    })),
    provideToastr({
      countDuplicates: true,
      tapToDismiss: false,
      closeButton: true,
      maxOpened: 3,
      progressBar: false,
      progressAnimation: 'decreasing',
      enableHtml: true,
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'de',
      lang: 'de'
    })
  ]
};
export default appConfig
